import { FC, useEffect, useMemo } from 'react';
import { List } from 'antd';
import { useQuery } from '@apollo/client';
import {
  GET_PATIENT_APPOINTMENTS_LINKS,
  GET_PREVIOUS_FILES_PATIENT
} from 'gql/appointments/queries';
import { PreviousFilesPatient } from 'gql/appointments/__generated__/PreviousFilesPatient';
import { StyledListItemContent } from 'theme/styled';
import { PatientAppointmentsLinks } from 'gql/appointments/__generated__/PatientAppointmentsLinks';

import FileItem from './FileItem';
import { showErrorMessage } from 'utils/showErrorMessage';

interface IProps {
  id: string;
  setTotal(total: number): void;
}

const Files: FC<IProps> = ({ id, setTotal }) => {
  const links = useQuery<PatientAppointmentsLinks>(
    GET_PATIENT_APPOINTMENTS_LINKS,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      variables: {
        query: {
          name: '',
          plan_type: '',
          patient: id,
          pagination: {
            page: 0,
            limit: 9999
          }
        }
      },
      onError: err => showErrorMessage(err)
    }
  );

  const files = useQuery<PreviousFilesPatient>(GET_PREVIOUS_FILES_PATIENT, {
    variables: {
      id
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  const filesResults = useMemo(
    () =>
      files.data?.previousFilesPatient?.data?.map(item => ({
        file: item.file,
        created_at: item.created_at,
        appointment_id: item.appointment_id,
        link: ''
      })) || [],
    [files.data?.previousFilesPatient?.data]
  );

  const linkResults = useMemo(
    () =>
      links.data?.appointmentsForDoctor.data.results
        ?.map(item =>
          item.links.map((link: string) => ({
            file: '',
            created_at: '',
            appointment_id: item.id,
            link
          }))
        )
        ?.flat() || [],
    [links.data?.appointmentsForDoctor.data.results]
  );

  useEffect(() => {
    if (filesResults.length || linkResults.length) {
      setTotal((filesResults.length || 0) + (linkResults.length || 0));
    }
  }, [filesResults.length, linkResults.length, setTotal]);

  return (
    <StyledListItemContent>
      <List
        loading={files.loading}
        dataSource={[...filesResults, ...linkResults]}
        renderItem={item => (
          <List.Item className="list-content-item">
            <FileItem
              date={item.created_at}
              link={item.link}
              file={item.file}
              appointmentId={item.appointment_id}
            />
          </List.Item>
        )}
      />
    </StyledListItemContent>
  );
};

export default Files;
